<template lang="pug">
  div.order-7(:class="$style.reviewsSection")
      div.flex.flex-col.gap-ds-md.w-full(class="md:flex-row md:justify-between items-center")
          // Truck section - always inline
          div.flex.items-center.gap-ds-ms
              img(:src="MovingTruck", alt="Moving Truck", class="w-[34px] h-[34px]")
              span.text-base.whitespace-nowrap
                b {{ numberOfMovesFormatted }}+
                |  {{ $t("home_card_header.furniture") }}

          // Trustpilot section - all elements inline
          div.flex.items-center.gap-ds-ms
            client-only(v-if="trustpilotRating !== '0'")
              .flex.items-center.gap-ds-sm
                figure.flex.items-center
                  img(
                  src="~/assets/img/trustpilot/brand/brandmark_gr-blk.svg"
                  class="h-[18px] w-auto"
                  alt="Trustpilot")
                figure.flex.items-center
                  img(
                  src="~/assets/img/trustpilot/brand/stars-4.5.svg"
                  class="h-ds-ml w-auto"
                  alt="Trustpilot rating, 4.5 out of 5 stars")
                span.text-base.font-semibold {{ trustpilotRating }}
</template>

<script>
import MovingTruck from "@anyvan-ui/icons/svg/truck.svg?url"

export default {
  name: "FormFooter",

  props: {
    trustpilotCustomers: {
      type: String,
      default: "0"
    },
    trustpilotRating: {
      type: String,
      default: "0"
    },
  },

  data() {
    const { locale } = useI18n()
    return {
      MovingTruck,
      numberOfMovesFormatted: formatNumberWithLocale(100_000, locale.value)
    }
  }
}
</script>

<style lang="scss" module>
.reviewsSection {
  @apply flex items-center w-full px-ds-ml py-[20px] order-7;
  border-radius: 0px 0px 6px 6px;
  background: var(--mono-100, #F7F7F7);
  box-shadow:
  0 2px 6px 2px rgba(0, 0, 0, 0.15),
  0 1px 2px 0 rgba(0, 0, 0, 0.3);

  @screen md {
    @apply px-ds-lg py-ds-md;
  }
}

</style>
